
//Greek letters code - http://www.javascripter.net/faq/greekletters.htm

module.exports = {

    convertAwakeningValueToRating(value) {
        let rating = "";

        if (value / 10000 < 4.3)
            rating = "E-";
        else if (value / 10000 < 24.1)
            rating = "E";
        else if (value / 10000 < 52.9)
            rating = "E+";
        else if (value / 10000 < 72.9)
            rating = "D-";
        else if (value / 10000 < 82.1)
            rating = "D";
        else if (value / 10000 < 86.9)
            rating = "D+";
        else if (value / 10000 < 91.3)
            rating = "C-";
        else if (value / 10000 < 95.6)
            rating = "C";
        else if (value / 10000 < 97.73)
            rating = "C+";
        else if (value / 10000 < 99.35)
            rating = "B-";
        else if (value / 10000 < 99.9)
            rating = "B";
        else if (value / 10000 < 99.9745)
            rating = "B+";
        else if (value / 10000 < 99.9895)
            rating = "A-";
        else if (value / 10000 < 99.996)
            rating = "A";
        else if (value / 10000 < 99.9985)
            rating = "A+";
        else if (value / 10000 < 99.999)
            rating = "S";
        else if (value / 10000 < 99.9995)
            rating = "SS";
        else
            rating = "SSS";

        return rating;
    },

    getAwakenRatingText(rating) {
        let text = "";

        if (rating.startsWith('E')) {
            if (rating.endsWith('-'))
                text = "<:E_minus:983729339860410388>";
            else if (rating.endsWith('+'))
                text = "<:E_plus:983729340892184618>";
            else
                text = "<:E_:983701106951610378>";
        }
        else if (rating.startsWith('D')) {
            if (rating.endsWith('-'))
                text = "<:D_minus:983730135868010586>";
            else if (rating.endsWith('+'))
                text = "<:D_plus:983730137109520384>";
            else
                text = "<:D_:983701103705227274>";
        }
        else if (rating.startsWith('C')) {
            if (rating.endsWith('-'))
                text = "<:C_minus:983730270769406085>";
            else if (rating.endsWith('+'))
                text = "<:C_plus:983730272333869086>";
            else
                text = "<:C_:983701099640946728>";
        }
        else if (rating.startsWith('B')) {
            if (rating.endsWith('-'))
                text = "<:B_minus:983730268814864444>";
            else if (rating.endsWith('+'))
                text = "<:B_plus:983730269796335736>";
            else
                text = "<:B_:983701095496941588>";
        }
        else if (rating.startsWith('A')) {
            if (rating.endsWith('-'))
                text = "<:A_minus:983730266893848606>";
            else if (rating.endsWith('+'))
                text = "<:A_plus:983730267887906877>";
            else
                text = "<:A_:983701092103753779>";
        }
        else if (rating.startsWith('S')) {
            text = "<:S_:983701110617432084>";
        }

        return text;
    },

    getAwkeningRatingForAttHP(value) {
        let rating = "";

        if (value >= 1 && value <= 199)
            rating = "E-";
        else if (value >= 200 && value <= 399)
            rating = "E";
        else if (value >= 400 && value <= 599)
            rating = "E+";
        else if (value >= 600 && value <= 799)
            rating = "D-";
        else if (value >= 800 && value <= 999)
            rating = "D";
        else if (value >= 1000 && value <= 1199)
            rating = "D+";
        else if (value >= 1200 && value <= 1599)
            rating = "C-";
        else if (value >= 1600 && value <= 2099)
            rating = "C";
        else if (value >= 2100 && value <= 2699)
            rating = "C+";
        else if (value >= 2700 && value <= 3499)
            rating = "B-";
        else if (value >= 3500 && value <= 4399)
            rating = "B";
        else if (value >= 4400 && value <= 5399)
            rating = "B+";
        else if (value >= 5400 && value <= 6299)
            rating = "A-";
        else if (value >= 6300 && value <= 7199)
            rating = "A";
        else if (value >= 7200 && value <= 8099)
            rating = "A+";
        else
            rating = "S";

        return rating;
    },

    getAwkeningRatingForSpd(value) {
        let rating = "";

        if (value >= 1 && value <= 1)
            rating = "E-";
        else if (value >= 2 && value <= 3)
            rating = "E";
        else if (value >= 4 && value <= 5)
            rating = "E+";
        else if (value >= 6 && value <= 7)
            rating = "D-";
        else if (value >= 8 && value <= 9)
            rating = "D";
        else if (value >= 10 && value <= 11)
            rating = "D+";
        else if (value >= 12 && value <= 15)
            rating = "C-";
        else if (value >= 16 && value <= 20)
            rating = "C";
        else if (value >= 21 && value <= 26)
            rating = "C+";
        else if (value >= 27 && value <= 34)
            rating = "B-";
        else if (value >= 35 && value <= 43)
            rating = "B";
        else if (value >= 44 && value <= 53)
            rating = "B+";
        else if (value >= 54 && value <= 62)
            rating = "A-";
        else if (value >= 63 && value <= 71)
            rating = "A";
        else if (value >= 72 && value <= 80)
            rating = "A+";
        else
            rating = "S";

        return rating;
    },

    ordinal_suffix_of(i) {
        var j = i % 10,
            k = i % 100;
        if (j === 1 && k !== 11) {
            return i + "st";
        }
        if (j === 2 && k !== 12) {
            return i + "nd";
        }
        if (j === 3 && k !== 13) {
            return i + "rd";
        }
        return i + "th";
    },

    convertStringToNumber(value, dp) {
        if (value) {
            var number = parseFloat(value.toString().replaceAll(",", ""));

            if (number > 10 || number < -10)
                number = Math.floor(number);

            let decimalPlaces = 2;
            if (dp)
                decimalPlaces = dp;

            if (number >= 1000 || number <= -1000)
                return number.toLocaleString();
            else
                return number.toFixed(decimalPlaces);
        }
        else
            return value;
    },

    convertStringToNumberNoFloor(value, dp) {
        if (value) {
            var number = parseFloat(value.toString().replaceAll(",", ""));

            let decimalPlaces = 2;
            if (dp)
                decimalPlaces = dp;

            if (number >= 1000 || number <= -1000)
                return number.toLocaleString();
            else
                return number.toFixed(decimalPlaces);
        }
        else
            return value;
    },

    convertStringToInt(value) {
        if (value) {
            var number = parseFloat(value.toString().replaceAll(",", ""));

            number = Math.floor(number);

            if (number > 100)
                return number.toLocaleString();
            else
                return number;
        }
        else
            return value;
    },

    getValueFromString(value) {
        return getValueFromString(value);
    },

    getDetailsFromHistoryCode(lastCode) {
        let guild = '';
        let power = '';
        let ccl = '';
        let se = '';
        let pwrinc = '';
        let ss = '';

        if (lastCode) {
            let arr = lastCode.split('#');
            if (arr.length > 0) guild = arr[0];
            if (arr.length > 1) power = getValueFromString(arr[1]);
            if (arr.length > 2) ccl = getValueFromString(arr[2]);
            if (arr.length > 3) se = getValueFromString(arr[3]);
            if (arr.length > 4) pwrinc = getValueFromString(arr[4]);
            if (arr.length > 5) ss = getValueFromString(arr[5]);
        }

        let result = {
            guild: guild,
            power: power,
            ccl: ccl,
            se: se,
            pwrinc: pwrinc,
            ss: ss,
        }

        return result;
    },

    getDetailsFromHistoryCodeForGuild(lastCode) {
        let guild = '';
        let power = '';
        let ccl = '';
        let se = '';
        let sepos = '';
        let ace = '';

        if (lastCode) {
            let arr = lastCode.split('#');
            if (arr.length > 0) guild = arr[0];
            if (arr.length > 1) power = getValueFromString(arr[1]);
            if (arr.length > 2) se = getValueFromString(arr[2]);
            if (arr.length > 3) sepos = getValueFromString(arr[3]);
            if (arr.length > 4) ace = getValueFromString(arr[4]);
            if (arr.length > 5) ccl = getValueFromString(arr[5]);
        }

        let result = {
            guild: guild,
            power: power,
            ccl: ccl,
            se: se,
            ace: ace,
            sepos: sepos,
        }

        return result;
    },

    calculateSS2(v1, v2, v3, v4, t1, t2, t3, t4, t5, t6, d1, d2, d3, d4, d5, d6, extraSS) {
        return calculateSSInternal(v1, v2, v3, v4, t1, t2, t3, t4, t5, t6, d1, d2, d3, d4, d5, d6, extraSS);
    },

    calculateSS(member) {
        return calculateSSInternal(member.v1, member.v2, member.v3, member.v4, member.t1, member.t2, member.t3, member.t4, member.t5, null /* t6 */,
            member.d1, member.d2, member.d3, member.d4, member.d5, member.d6, member.extraSS);
    }
}

function calculateSSInternal(v1, v2, v3, v4, t1, t2, t3, t4, t5, t6, d1, d2, d3, d4, d5, d6, extraSS) {
    let ss = 0;

    if (v1) ss = ss + v1 * 0.138;
    if (v2) ss = ss + v2 * 0.726;
    if (v3) ss = ss + v3 * 2.184;
    if (v4) ss = ss + v4 * 4.935;
    if (t1) ss = ss + t1 * 5.265;
    if (t2) ss = ss + t2 * 5.880;
    if (t3) ss = ss + t3 * 7.007;
    if (t4) ss = ss + t4 * 8.784;
    if (t5) ss = ss + t5 * 11.372;
    if (t6) ss = ss + t6 * 14.929;
    if (d1) ss = ss + d1 * 15.751;
    if (d2) ss = ss + d2 * 16.906;
    if (d3) ss = ss + d3 * 18.391;
    if (d4) ss = ss + d4 * 20.206;
    if (d5) ss = ss + d5 * 22.351;
    if (d6) ss = ss + d6 * 24.929;
    if (extraSS) ss = ss + extraSS;

    return ss;
};

function getValueFromString(value) {
    let result = 0;

    if (value) {
        value = value.toString().replaceAll(',', '');
        value = value.toString().replaceAll('%', '');

        result = parseFloat(value);
    }

    return result;
};